import { render, staticRenderFns } from "./pageResumen.vue?vue&type=template&id=5c28955e&scoped=true&"
import script from "./pageResumen.vue?vue&type=script&lang=js&"
export * from "./pageResumen.vue?vue&type=script&lang=js&"
import style0 from "./pageResumen.vue?vue&type=style&index=0&id=5c28955e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c28955e",
  null
  
)

export default component.exports